import { render } from "./SpeakerDetailDialog.vue?vue&type=template&id=685321ec&scoped=true&ts=true"
import script from "./SpeakerDetailDialog.vue?vue&type=script&lang=ts"
export * from "./SpeakerDetailDialog.vue?vue&type=script&lang=ts"

import "./SpeakerDetailDialog.vue?vue&type=style&index=0&id=685321ec&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\program-list-inh26\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685321ec"]])

export default __exports__